export default __webpack_public_path__ + "static/media/mlh-prep.270f6887.png";